export enum workloadViewTypes {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}
